/**
 * Datos de contacto de la clínica que aparecen en la web y en los impresos.
 *
 * Viven aquí y no repartidos por las páginas porque son los mismos en la
 * landing, en la receta y en el certificado: cuando el cliente confirme los
 * definitivos se cambian en un solo lugar.
 *
 * TODO-NEGOCIO: todos los valores son placeholders hasta que Chejo confirme
 * teléfono, WhatsApp, dominio y dirección definitivos.
 */

export const CLINIC = {
  name: 'Cima Sport',
  /** TODO-NEGOCIO: teléfono real de la unidad. */
  phone: '+56 2 2555 0000',
  /** TODO-NEGOCIO: número real de WhatsApp. */
  whatsappNumber: '56900000000',
  /** TODO-NEGOCIO: confirmar la dirección exacta de la unidad. */
  address: 'Gran Avenida 4564, San Miguel, Santiago',
} as const

export const WHATSAPP_URL = `https://wa.me/${CLINIC.whatsappNumber}?text=${encodeURIComponent(
  'Hola, quiero agendar una hora en Cima Sport',
)}`

/**
 * Base pública del sitio. En el navegador siempre es el origen actual — el
 * dominio definitivo aún no está decidido (sigue pendiente en nic.cl), así que
 * no se escribe a mano en ninguna parte.
 */
export function publicBaseUrl(): string {
  return typeof window === 'undefined' ? '' : window.location.origin
}

/** Página pública donde se agenda (CTA de reagendamiento de los impresos). */
export function bookingUrl(): string {
  return `${publicBaseUrl()}/#contacto`
}
